import { BaseResult } from "./BaseResult";

export class LoginResult extends BaseResult {
  public token: string = '';
  public expirationDate: number = 0;

  constructor(init?: Partial<LoginResult>) {
    super(init);
    Object.assign(this, init);
  }
}
